import React from 'react';
import { Home } from 'lucide-react';
import { Link } from 'react-router-dom';

const ErrorPage = () => {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="text-center px-4">
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <h2 className="text-2xl mb-6">Seite nicht gefunden</h2>
        <p className="text-gray-400 mb-8 max-w-md mx-auto">
          Die von Ihnen gesuchte Seite existiert leider nicht. 
          Möglicherweise wurde sie verschoben oder gelöscht.
        </p>
        <Link
          to="/"
          className="inline-flex items-center px-6 py-3 bg-white text-black rounded-full hover:bg-gray-200 transition-colors"
        >
          <Home className="mr-2" size={20} />
          Zur Startseite
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;